import { store } from "../../store";
import { addAuditEvent } from "../../ReduxSlices/AuditEvents/AuditEventSlice";
import subscribeToCoreUpdates from "../core_updates_channel";

let unsubscribeAudit = null;

export const initializeAuditSubscription = () => {
  if (unsubscribeAudit) return;

  unsubscribeAudit = subscribeToCoreUpdates("audit", {
  "audit_event.created": (data) => {
  // console.log("🔥 AUDIT EVENT RECEIVED:", data);
  store.dispatch(addAuditEvent(data));
  }
  });
};

export const unsubscribeAuditSubscription = () => {
  if (unsubscribeAudit) {
    unsubscribeAudit();
    unsubscribeAudit = null;
  }
};